module.exports = __webpack_public_path__ + "img/Imagen1.8aa33dfd.webp";